import styles from "./ListAssetCardContainer.module.scss";
import { ReactNode } from "react";
import clsx from "clsx";

export default function ListAssetCardContainer({
  children,
  tagName: TagName,
  className,
}: {
  children: ReactNode;
  tagName: "li" | "div";
  className?: ReactNode;
}) {
  return (
    <TagName className={clsx(styles.container, className)}>{children}</TagName>
  );
}
